import { Injectable } from '@angular/core';
import {
    AlertController,
    LoadingController,
    ToastController,
    ModalController,
    type AlertOptions,
    type ModalOptions
} from '@ionic/angular';
// import type { AlertOptions, LoadingOptions, ToastOptions } from '@ionic/core';
// import { HTMLIonLoadingElement } from '@ionic/angular';
// import { NONE_TYPE } from '@angular/compiler/src/output/output_ast';
// import { Howl, /* Howler */ } from 'howler';
import { Howl /* Howler */ } from 'howler';
import type { TResponse } from '@shared/models';

// import { NativeAudio }                 from '@ionic-native/native-audio';
// import { Howl } from 'Howler';
// import 'Howler';    // this works
// ptb import { Howl } from 'howler';

@Injectable({
    'providedIn': 'root'
})
export class UxHelperService {
    private DEFAULT_TOAST_DURATION = 2000;
    private spinners: HTMLIonLoadingElement[] = [];
    private sound!: Howl;

    constructor(private alertController: AlertController, private toastCtrl: ToastController,
        private loadingController: LoadingController,
        private modalController: ModalController) {
    }

    /**
     * Show confirmation alert with Cancel and Okay buttons
     * Returns a promise that resolves with selection result
     * @returns {okay: true} if Okay clicked, {okay: false} if Cancel clicked
     */
    public async showAlert(title: string, message: string): Promise<TResponse> {
        const promise = new Promise<TResponse>((resolve) => {
            const options: AlertOptions = {
                'header': title,
                'message': message,
                'buttons': [
                    {
                        'text': 'Cancel',
                        'role': 'cancel',
                        'cssClass': 'alert-button-cancel secondary',
                        'handler': () => {
                            resolve({ 'okay': false, 'selectedItems': null });
                        }
                    },
                    {
                        'text': 'Okay',
                        'role': 'okay',
                        'cssClass': 'alert-button-okay primary',
                        'handler': () => {
                            resolve({ 'okay': true, 'selectedItems': null });
                        }
                    }
                ]
            };

            this.alertController.create(options).then(alert => alert.present());
        });

        return promise;
    }

    // public async showAlert(title: string, message: string): Promise<void> {
    //     const alert = await this.alertController.create({
    //         'header': title,
    //         'message': message,
    //         'buttons': [
    //             {
    //                 'text': 'Okay',
    //                 'role': 'okay',
    //                 'handler': () => {
    //                     if (callback) {
    //                         callback({ 'okay': true, 'selectedItems': [] });
    //                     }
    //                 }
    //             }
    //         ]
    //     });
    //     await alert.present();
    // }

    // public async showConfirmationAlert(title: string, message: string, callback: (arg: object) => void) {
    //     const alert = await this.alertController.create({
    //         'header': title,
    //         'message': message,
    //         'buttons': [
    //             {
    //                 'text': 'Cancel',
    //                 'role': 'cancel',
    //                 'cssClass': 'secondary',
    //                 'handler': () => {
    //                     callback({ 'selection': false });
    //                 }
    //             },
    //             {
    //                 'text': 'Okay',
    //                 'role': 'okay',
    //                 'handler': () => {
    //                     callback({ 'selection': true });
    //                 }
    //             }
    //         ]
    //     });
    //     await alert.present();
    // }

    // public async showConfirmationAlert(title: string, message: string, callback: (arg: TResponse) => void) {
    //     const alert = await this.alertController.create({
    //         'header': title,
    //         'message': message,
    //         'buttons': [
    //             {
    //                 'text': 'Cancel',
    //                 'role': 'cancel',
    //                 'cssClass': 'secondary',
    //                 'handler': () => {
    //                     const response: TResponse = { 'okay': false, 'selectedItems': [] };
    //                     callback(response);
    //                 }
    //             },
    //             {
    //                 'text': 'Okay',
    //                 'role': 'okay',
    //                 'handler': () => {
    //                     const response: TResponse = { 'okay': true, 'selectedItems': [] };
    //                     callback(response);
    //                 }
    //             }
    //         ]
    //     });
    //     await alert.present();
    // }

    // public async showRadioAlert(title: string, list: Array<string>, checkedItem: string, callback: (arg: TResponse) => void) {
    public async showRadioAlert2(
        title: string,
        list: Array<string>,
        checkedItem: string,
        radioModalComponent: NonNullable<ModalOptions['component']>
    ): Promise<TResponse> {
        const options: ModalOptions = {
            component: radioModalComponent,
            componentProps: {
                'items': list,
                'selectedItem': checkedItem,
                'title': title
            },
            backdropDismiss: false,
            showBackdrop: true,
            cssClass: 'myModalSize'
        };

        const myModal = await this.modalController.create(options);
        await myModal.present();
        const response: any = await myModal.onDidDismiss();

        if (response?.data?.okay) {
            return {
                'okay': true,
                'selectedItems': response.data.selectedItem ?? null
            };
        }

        return {
            'okay': false,
            'selectedItems': null
        };
    }

    public async showRadioAlert(title: string, list: Array<string>, checkedItem: string): Promise<TResponse> {
        const inputs: { type: string; label: string; value: string; checked: boolean; }[] = [];

        const promise = new Promise<TResponse>((resolve) => {
            list.forEach((item) => {
                const check = (item === checkedItem) ? true : false;
                const input = {
                    'type': 'radio',
                    'label': item,
                    'value': item,
                    'checked': check
                };
                inputs.push(input);
            });

            const options = {
                'header': title,
                'inputs': inputs,
                'buttons': [
                    {
                        'text': 'Cancel',
                        'role': 'cancel',
                        'cssClass': 'secondary',
                        'handler': (data: TResponse) => {
                            resolve({ 'okay': false, 'selectedItems': null });
                        }
                    }, 
                    {
                        'text': 'Ok',
                        // 'handler': (data: TAlertResponse) => {
                        'handler': (data: string) => {
                            resolve({ 'okay': true, 'selectedItems': [data] });
                        }
                        // if (callback) {
                        //     // callback({ 'selection': data });
                        //     response = { 'okay': true, 'selectedItems': data };
                        //     callback(response);
                        // }
                    }
                ]
            };

            const presentAlert = async () => {
                const alert = await this.alertController.create(options as any);
                await alert.present();
            };

            void presentAlert();
        });

        return promise;
    }

    // Do not use this method.  Instead use the one in checkboxModal.page.ts. 
    // public async showCheckboxAlert(title: string, allItems: string[], checkedItems: string[]): Promise<TAlertResponse> {
    //     const inputs: { type: string; label: string; value: string; checked: boolean; }[] = [];

    //     allItems.forEach((item) => {
    //         const check = checkedItems.includes(item);
    //         const input = {
    //             'type': 'checkbox',
    //             'label': item,
    //             'value': item,
    //             'checked': check
    //         };
    //         inputs.push(input);
    //     });

    //     const promise = new Promise<TAlertResponse>(async (resolve) => {
    //         const options = {
    //             'inputs': inputs,
    //             'buttons': [
    //                 {
    //                     'text': 'Cancel',
    //                     'role': 'cancel',
    //                     'cssClass': 'secondary',
    //                     'handler': (data: TAlertResponse) => {
    //                         resolve({ 'selection': false, 'value': null });
    //                     }
    //                 }, {
    //                     'text': 'Ok',
    //                     'handler': (data: string) => {
    //                         resolve({ 'selection': true, value: data });
    //                     }
    //                 }
    //             ]
    //         };

    //         const alert = await this.alertController.create(options as any);
    //         await alert.present();
    //     });

    //     return promise;
    // }

    // #endregion

    // #region Spinner Section
    public async showSpinner(msg = ''): Promise<void> {
        if (this.spinners.length > 0) {
            return;
        }

        msg += '  Please wait a moment...';
        msg = msg.trim();

        const options: any = {
            'message': msg,
            'spinner': 'crescent',
            'cssClass': 'mySpinnerOptions'
        };

        // Holding the spinner in an array, allows nested spinners to be created.
        // For an example of nested spinners, see the dealership.load() and dealership.onZipcodeChange().
        const spinner = await this.loadingController.create(options);
        this.spinners.push(spinner as never);
        await spinner.present();
    }

    public async hideSpinner(): Promise<void> {
        const spinner = this.spinners.pop();
        if (spinner) {
            await spinner.dismiss();
        }

        // if (this.spinner) {
        //     await this.spinner.dismiss();
        //     this.spinner = null;
        // }
    }

    // #region Misc Section

    // public verifyValue(fieldValue, errMsg: string) {
    //     if (fieldValue === undefined || fieldValue === null || fieldValue.length === 0) {
    //         this.showAlert('Error', errMsg);
    //         return false;
    //     }

    //     return true;
    // }

    // / start new
    // public async presentAlertPrompt() {
    //     const alert = await this.alertController.create({
    //       cssClass: 'my-custom-class',
    //       header: 'Prompt!',
    //       inputs: [
    //         {
    //           name: 'name1',
    //           type: 'text',
    //           placeholder: 'Placeholder 1'
    //         },
    //         {
    //           name: 'name2',
    //           type: 'text',
    //           id: 'name2-id',
    //           value: 'hello',
    //           placeholder: 'Placeholder 2'
    //         },
    //         // multiline input.
    //         {
    //           name: 'paragraph',
    //           id: 'paragraph',
    //           type: 'textarea',
    //           placeholder: 'Placeholder 3'
    //         },
    //         {
    //           name: 'name3',
    //           value: 'http://ionicframework.com',
    //           type: 'url',
    //           placeholder: 'Favorite site ever'
    //         },
    //         // input date with min & max
    //         {
    //           name: 'name4',
    //           type: 'date',
    //           min: '2017-03-01',
    //           max: '2018-01-12'
    //         },
    //         // input date without min nor max
    //         {
    //           name: 'name5',
    //           type: 'date'
    //         },
    //         {
    //           name: 'name6',
    //           type: 'number',
    //           min: -5,
    //           max: 10
    //         },
    //         {
    //           name: 'name7',
    //           type: 'number'
    //         },
    //         {
    //           name: 'name8',
    //           type: 'password',
    //           placeholder: 'Advanced Attributes',
    //           cssClass: 'specialClass',
    //           attributes: {
    //             maxlength: 4,
    //             inputmode: 'decimal'
    //           }
    //         }
    //       ],
    //       buttons: [
    //         {
    //           text: 'Cancel',
    //           role: 'cancel',
    //           cssClass: 'secondary',
    //           handler: () => {
    //           }
    //         }, {
    //           text: 'Ok',
    //           handler: () => {
    //           }
    //         }
    //       ]
    //     });
    //     await alert.present();
    //   }


    public async promptForString(header: string, msg: string, defaultValue: string): Promise<TResponse> {
        const promise = new Promise<TResponse>((resolve) => {
            const opts: any = {
                'cssClass': 'myPromptForString',
                'header': header,
                'subheader': 'subheader',
                'message': msg,
                'inputs': [
                    {
                        'name': 'value',
                        'type': 'text',
                        'message': msg,
                        'value': defaultValue,
                    },
                ],
                'buttons': [
                    {
                        'text': 'Cancel',
                        'role': 'cancel',
                        'cssClass': 'secondary',
                        'handler': () => {
                            resolve({ 'okay': false, 'selectedItems': [defaultValue] });
                        }
                    },
                    {
                        'text': 'Ok',
                        // TODO: Remove TData and replace with TResponse
                        'handler': (data: TResponse) => {
                            resolve({ 'okay': true, 'selectedItems': data.selectedItems });
                        }
                    }
                ]
            };

            // const alert = await this.alertController.create(opts as any);
            // await alert.present();
            this.alertController.create(opts as any)
                .then(async (alert) => alert.present());
        });

        return promise;
    }   

    // The selectables array is  an array of objects that have a 'name' column and a value.
    public convertArrayToSelectables(arr: string[]): unknown[] {
        const selectables: unknown[] = [];
        arr.forEach((item) => {
            const obj = { 'name': item };
            selectables.push(obj);
        });

        return selectables;
    }
    // #endregion

    // #region Sound Section
    public playSound(filename: string): void {
        const source: string[] = [];
        source.push(filename);

        this.sound = new Howl({ 'src': source });
        this.sound.play();
    }

    public stopSound(): void {
        this.sound.stop();
    }

    public playSentSmsSound(): void {
        this.playSound('assets/audio/Flyby.mp3');
    }

    public playPickupAlert(): void {
        this.playBeep();
        // this.playSound('assets/audio/SundayChurchAmbiance.mp3');
    }

    public playTypingSound(): void {
        this.playSound('assets/audio/KeyboardTyping.mp3');
    }

    public playBeep(): void {
        this.playSound('assets/audio/Beep.mp3');

        // new Audio('assets/audio/Beep.mp3').play();

        // this.nativeAudio.preloadSimple('beepId', 'assets/audio/Beep.mp3')
        // .then(() => {
        //     this.nativeAudio.play('beepId');
        // })
        // .catch(err => {
        // });
    }

    // #endregion

    // #region Toast Section
    public async showToast(message: string): Promise<void> {
        const options: any = {
            'message': message,
            'duration': this.DEFAULT_TOAST_DURATION,
            'position': 'bottom',
            'animated': true,
            'cssClass': 'myToastOptions'
        };
        const toast = await this.toastCtrl.create(options);
        await toast.present();
    }

    public async showToastWithCloseButton(message: string): Promise<void> {
        const options: any = {
            'message': message,
            'cssClass': 'myToastOptionsWithClose',
            'buttons': [
                {
                    'text': 'Close',
                    'role': 'cancel',
                }
            ]
        };
        const toast = await this.toastCtrl.create(options);
        await toast.present();
    }
}
